<!-- Main container -->
<div class="layout-col full">
  <elder-table class="flex" [data]="data" [selectionVisible]="false" matSort>
    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let row">
        <span class="layout-row place-start-center">
          <mat-icon>label</mat-icon>
        </span>
      </td>
    </ng-container>

    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 25%">{{ 'ID' | translate }}</th>
      <td mat-cell *matCellDef="let group">
        <div class="layout-col">
          <span>{{ group.description }}</span>
          <span class="text-body-small">{{ group.id }}</span>
        </div>
      </td>
    </ng-container>

    <!-- baseLocation Column -->
    <ng-container matColumnDef="baseLocation">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'storage.stagingArea' | translate }}
      </th>
      <td mat-cell *matCellDef="let group">{{ group.baseLocation }}</td>
    </ng-container>

    <!-- currentPackageLocation Column -->
    <ng-container matColumnDef="currentPackageLocation">
      <th mat-header-cell *matHeaderCellDef>{{ 'storage.currentLocation' | translate }}</th>
      <td mat-cell *matCellDef="let group">
        @for (
          pkgLocation of group.packageDetails?.total.packageLocations;
          track pkgLocation;
          let last = $last
        ) {
          <span>{{ group.currentPackageLocation }}</span>
          @if (!last) {
            <span>, </span>
          }
        }
      </td>
    </ng-container>

    <!-- expectedWeight Column -->
    <ng-container matColumnDef="expectedPackageWeight">
      <th
        mat-header-cell
        *matHeaderCellDef
        style="width: 15%"
        elderNumberCell
        mat-sort-header="expectedPackageWeight.value"
      >
        {{ 'context.expectedWeight' | translate }}
      </th>
      <td mat-cell *matCellDef="let group" elderNumberCell>
        {{ group.expectedPackageWeight | elderQuantity }}
      </td>
    </ng-container>

    <!-- packageWeight Column -->
    <ng-container matColumnDef="currentPackageWeight">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" elderNumberCell>
        {{ 'context.confirmedWeight' | translate }}
      </th>
      <td mat-cell *matCellDef="let group" elderNumberCell>
        {{ (group.packageDetails?.confirmation.confirmed.contentWeight | elderQuantity) || '?' }}
      </td>
    </ng-container>

    <!-- packageCount Column -->
    <ng-container matColumnDef="currentPackageCount">
      <th mat-header-cell *matHeaderCellDef style="width: 5%" elderNumberCell>
        {{ 'packages.confirmedPackageCount' | translate }}
      </th>
      <td mat-cell *matCellDef="let group" elderNumberCell>
        {{ group.packageDetails?.confirmation.confirmed.packageCount || '?' }}
      </td>
    </ng-container>
  </elder-table>
</div>
